




















import {Breadcrumb, Icon} from 'ant-design-vue';
// Vue.component(Icon.name, Icon);
// Vue.component(Breadcrumb.name, Breadcrumb);
// Vue.component(Breadcrumb.Item.name, Breadcrumb.Item);

import {
  Component,
  Prop,
  Vue,
  Emit,
  Watch,
} from 'vue-property-decorator';
import * as _ from 'lodash';

@Component({
  components: {
    [Icon.name]: Icon,
    [Breadcrumb.name]: Breadcrumb,
    [Breadcrumb.Item.name]: Breadcrumb.Item,
  },
})
export default class BreadcrumbList extends Vue {

  get source() {
    return this.$route.matched;
  }

  private mounted() {
  }

}
